import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { buttonStyle } from "src/styles/buttonstyle";

type MainButtonProps = {
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void | Promise<void>;
  text: string;
  sx?: object;
};

export default function MainButton({
  disabled,
  onClick,
  isLoading,
  text,
  sx,
}: MainButtonProps) {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      disabled={disabled}
      sx={{
        alignSelf: "center",
        borderRadius: "20px",
        color: "white",
        ...buttonStyle,
        transition:
          "transform 160ms ease, box-shadow 160ms ease, background-color 140ms ease",
        backgroundColor:
          buttonStyle?.bgcolor ?? ((t: any) => t.palette.primary.main),
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        "&:hover": {
          backgroundColor: buttonStyle?.hoverBg,

          boxShadow: "0 6px 18px rgba(0,0,0,0.10)",
        },

        // Active (pressed): small push-down, remove transform
        "&:active": {
          transform: "translateY(0)",
          boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
        },

        // Keep focus-visible for keyboard users
        "&:focus-visible": {
          outline: "3px solid rgba(57,128,209,0.18)",
          outlineOffset: "3px",
        },

        // Disabled visual
        "&.Mui-disabled": {
          opacity: 0.65,
          pointerEvents: "none",
          boxShadow: "none",
          transform: "none",
        },
        ...sx,
      }}
    >
      {isLoading ? <CircularProgress size={24} color="inherit" /> : text}
    </Button>
  );
}
